import React from 'react'
import { Field, FieldArray, reduxForm } from 'redux-form'
import Moment from "moment";
import { Button, Table } from 'react-bootstrap';

const required = value => value ? undefined : 'Required'
const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined

const renderField = ({ input, label, type, meta: { touched, error } }) => (
    <div>
      <input {...input} type={type} placeholder={label} style={{width: '100%'}} />
      {touched && error && <span>{error}</span>}
    </div>
)



const renderFields = ({ fields, meta: { error } }) => (
  <React.Fragment>
    {fields.map((page, index) => (
      <React.Fragment key={index}>
        <tr style={{background: '#00800038'}}>
            <td>
              <Field
                name={`${page}`}
                type="text"
                component={renderField}
                label={`Company Name`}
                validate={[ required ]}
              />
            </td>
            <td>
              <button type="button" onClick={() => fields.remove(index)}>❌</button>
            </td>
        </tr>
      </React.Fragment>
    ))}
    <tr>
        <td colSpan="2">
          <button type="button" className="btn btn-primary btn-sm" onClick={() => fields.push()}>
            Add New Domain
          </button>
        </td>
    </tr>
  </React.Fragment>
)


const ImEditorForm = props => {
	const { handleSubmit, submitting, reset, pristine, initialValues} = props
	return (
     <form onSubmit={handleSubmit}>
       <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Id</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{background: '#00800038'}}>
            <td>
              <Field
                name={`name`}
                type="text"
                component={renderField}
                label={`Name`}
                validate={[ required ]}
              />
            </td>
            <td>
              <Field
                name={`id`}
                type="text"
                component={renderField}
                label={`Id`}
                validate={[ required, number ]}
              />
            </td>
          </tr>
          <tr colSpan="2" className="mt-2 mb-2"><td>Domain</td></tr>
          <FieldArray name="domain" component={renderFields} />
        </tbody>
        </Table>
        <div className="p-1">
          <button type="submit" className="btn btn-success btn-sm mr-2" disabled={submitting}>
            Save Changes
          </button>
          <button type="button" className="btn btn-primary btn-sm" disabled={pristine || submitting} onClick={reset}>
            Undo Values
          </button>
        </div>
    </form>
  )
}

export default reduxForm({
  form: 'ImEditorForm', // a unique identifier for this form
  enableReinitialize: true
})(ImEditorForm)


// WEBPACK FOOTER //
// ./src/components/Insights/ImEditorForm.js